import { render, staticRenderFns } from "./BannerMenu.vue?vue&type=template&id=70597733&"
import script from "./BannerMenu.vue?vue&type=script&lang=js&"
export * from "./BannerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports